module.exports = __webpack_public_path__ + "static/media/opakowania_01_A.020e77aa.png";